// extracted by mini-css-extract-plugin
export var additionalContent = "MediaTextTeaserElement-module--additionalContent--cb321";
export var alignMediaRight = "MediaTextTeaserElement-module--alignMediaRight--a4534";
export var anchored = "MediaTextTeaserElement-module--anchored--e0c60";
export var heading = "MediaTextTeaserElement-module--heading--19f87";
export var horizontal = "MediaTextTeaserElement-module--horizontal--9f686";
export var horizontalContent = "MediaTextTeaserElement-module--horizontalContent--252f0";
export var horizontalImage = "MediaTextTeaserElement-module--horizontalImage--b521d";
export var imageWrapper = "MediaTextTeaserElement-module--imageWrapper--02381";
export var mediaTextTeaserElement = "MediaTextTeaserElement-module--mediaTextTeaserElement--988a5";
export var teaserContent = "MediaTextTeaserElement-module--teaserContent--bb37b";
export var teaserImage = "MediaTextTeaserElement-module--teaserImage--6302e";
export var vertical = "MediaTextTeaserElement-module--vertical--562e9";